
<template>
	<page>
		<module>
			<view-list
				ref="view"
				work-type="33"
				selector
			>
				<template #search>
					<m-search ref="search">
						<m-search-item label="背贴码">
							<m-code-batch-input name="produce_codes" field-name="背贴码" placeholder="请输入背贴码，支持批量"></m-code-batch-input>
						</m-search-item>
						<m-search-item label="IMEI">
							<m-code-batch-input name="imeis" field-name="IMEI" placeholder="请输入IMEI，支持批量"></m-code-batch-input>
						</m-search-item>
						<m-search-item label="关键字">
							<c-input name="keyword" placeholder="售后单号/订单号"></c-input>
						</m-search-item>
						<m-search-item label="申请人">
							<c-input name="applicant" placeholder="姓名/手机号"></c-input>
						</m-search-item>
						<m-search-item label="退货快递">
							<c-input name="return_express" placeholder="快递公司/快递单号"></c-input>
						</m-search-item>
						<m-search-item label="申请时间" colspan="2">
							<c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
						</m-search-item>
					</m-search>
				</template>

				<!--批量按钮常驻（operate 常态插槽，有权限即显示）：未勾选时点击不传 data，由方法从列表兜底取选中行，为空则提示先勾选-->
				<template #operate>
					<c-button v-if="auth('b_online_aftersales_order_batch_audit')" prepend-icon="tf-approve" color="main" @click="batchAudit()">批量审核</c-button>
					<c-button v-if="auth('b_online_aftersales_order_batch_confirm_return')" prepend-icon="tf-accept" color="main" @click="batchConfirmReturn()">批量确认收货</c-button>
					<c-button v-if="auth('b_online_aftersales_order_batch_refund')" prepend-icon="tf-accept" color="main" @click="batchConfirmRefund()">批量确认退款</c-button>
					<c-button v-if="auth('b_online_aftersales_order_batch_return_machine')" prepend-icon="tf-accept" color="main" @click="batchConfirmReturnMachine()">批量确认退机</c-button>
					<c-button v-if="auth('b_online_aftersales_order_batch_reject')" prepend-icon="tf-reject" color="red" :hollow="true" @click="batchReject()">批量驳回</c-button>
					<!--列表导出（与列表同DAO同条件口径）-->
					<c-button v-if="auth('b_online_aftersales_order_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
				</template>

				<!--批量栏（已勾选态）：按钮可见性各自独立授权点位；行可选口径由服务端下发的 data.buttons 判定-->
				<template #batchOperate="{data}">
					<c-button v-if="auth('b_online_aftersales_order_batch_audit')" prepend-icon="tf-approve" color="main" @click="batchAudit(data)">批量审核</c-button>
					<c-button v-if="auth('b_online_aftersales_order_batch_confirm_return')" prepend-icon="tf-accept" color="main" @click="batchConfirmReturn(data)">批量确认收货</c-button>
					<c-button v-if="auth('b_online_aftersales_order_batch_refund')" prepend-icon="tf-accept" color="main" @click="batchConfirmRefund(data)">批量确认退款</c-button>
					<c-button v-if="auth('b_online_aftersales_order_batch_return_machine')" prepend-icon="tf-accept" color="main" @click="batchConfirmReturnMachine(data)">批量确认退机</c-button>
					<c-button v-if="auth('b_online_aftersales_order_batch_reject')" prepend-icon="tf-reject" color="red" :hollow="true" @click="batchReject(data)">批量驳回</c-button>
					<!--选中态 operate 槽被批量条替换，导出入口须在此复放（同客户/供应商列表先例）；勾选后仅导出选中行-->
					<c-button v-if="auth('b_online_aftersales_order_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
				</template>

				<template #refund_info="{data}">
					<span v-if="!Number(data.refund_amount)">-</span>
					<div v-else class="m-product-info">
						<p style="color: #e53e3e;">{{formatPrice(data.refund_amount)}}</p>
						<p class="m-product-info-code">{{data.refund_date || '-'}}</p>
					</div>
				</template>

				<template #product_info="{data}">
					<m-product-info :name="getProductText(data)" :level="data.level_type" :code="data.produce_code" :imei="data.produce_imei"></m-product-info>
				</template>



                <template #after_sale_type="{data}">
                    <c-state async dict="SALE_AFTER_SALE_TYPE" :value="data.after_sale_type"></c-state>
                </template>

				<template #after_sale_state="{data}">
					<c-state async dict="SALE_AFTER_SALE_STATE" :value="data.after_sale_state"></c-state>
				</template>

				<template #order_info="{data}">
					<div class="m-product-info">
						<p>{{data.order_no || '-'}}</p>
						<p class="m-product-info-code">三方订单号：{{data.third_party_order_no || data.order_no || '-'}}</p>
					</div>
				</template>

				<template #after_sale_amount="{data}">
					<span style="color: #e53e3e;">{{formatPrice(data.after_sale_amount)}}</span>
				</template>

				<template #applicant_info="{data}">
					<div class="m-product-info">
						<p v-if="data.applicant_name">{{data.applicant_name}}</p>
						<p v-if="data.applicant_phone" class="m-product-info-code">{{data.applicant_phone}}</p>
						<p v-if="!data.applicant_name && !data.applicant_phone">-</p>
					</div>
				</template>

				<template #return_express_info="{data}">
					<div class="m-product-info">
						<p v-if="data.return_express_company">{{data.return_express_company}}</p>
						<p v-if="data.return_express_no" class="m-product-info-code">{{data.return_express_no}}</p>
						<p v-if="!data.return_express_company && !data.return_express_no">-</p>
					</div>
				</template>

				<template #audit_user_id="{data}">
					{{data.audit_user_realname || '-'}}
				</template>
                <template #refund_user_id="{data}">
                    {{data.refund_user_realname || '-'}}
                </template>

				<c-table-column
					type="button"
					label="操作"
					width="160"
					button-limit="6"
				>
					<template #default="{data}">
						<c-table-button v-if="auth('b_online_aftersales_order_query')" icon="tf-detail" @click="viewDetail(data)">查看</c-table-button>
						<!--行级按钮可见性由服务端按渠道归属+状态+类型统一下发（data.buttons），端内只保留 auth 权限点位判断-->
						<c-table-button v-if="auth('b_online_aftersales_order_audit') && (data.buttons?.audit?.visible || data.buttons?.reject?.visible) && data.after_sale_state == 1" icon="tf-resolve" @click="viewDetail(data)">审批</c-table-button>
						<c-table-button v-if="auth('b_online_aftersales_order_confirm_return') && data.buttons?.confirm_return?.visible" icon="tf-accept" @click="confirmReturn(data)">确认收货</c-table-button>
						<!--确认退款可见性由服务端按渠道归属+状态+类型统一下发（三方渠道售后资金走渠道侧结算，buttons.refund 恒隐藏；自营按流程图对应状态放行），端内不再用裸 after_sale_state 判断-->
						<c-table-button v-if="auth('b_online_aftersales_order_refund') && data.buttons?.refund?.visible" icon="tf-accept" @click="confirmRefund(data)">确认退款</c-table-button>
						<!--三方同售渠道确认退机：可见性由服务端按渠道归属+状态+类型下发（data.buttons.return_machine），权限点复用确认收货-->
						<c-table-button v-if="auth('b_online_aftersales_order_confirm_return') && data.buttons?.return_machine?.visible" icon="tf-accept" @click="confirmReturnMachine(data)">确认退机</c-table-button>
					</template>
				</c-table-column>
			</view-list>

			<!-- 批量审核-退货地址弹窗（所选地址整批共用） -->
			<c-dialog ref="batchAddressDialog" title="批量审核" width="520">
				<div class="m-return-address-box">
					<label class="m-label"><span class="m-required">*</span> 请选择退货地址（整批共用）</label>
					<div class="m-return-address-list">
						<div
							v-for="item in addressList"
							:key="item.id"
							:class="['m-return-address-item', {'m-active': selectedAddressId == item.id}]"
							@click="selectedAddressId = item.id"
						>
							<i class="m-radio"></i>
							<span class="m-return-address-text">
								<span class="m-return-address-contact">{{item.name}}【{{item.phone}}】</span>
								<span class="m-return-address-addr">{{item.full_address}}</span>
							</span>
						</div>
						<div v-if="!addressList.length" class="m-return-address-empty">请先在地址管理中添加售后退货地址</div>
					</div>
					<p v-if="batchIgnoreTip" class="m-ignore-tip">{{batchIgnoreTip}}</p>
				</div>

				<template #button>
					<c-button size="dialog" color="main" @click="submitBatchAudit">确认审核</c-button>
					<c-button size="dialog" @click="$refs.batchAddressDialog.close()">取消</c-button>
				</template>
			</c-dialog>

			<!-- 批量驳回原因弹窗 -->
			<c-dialog ref="batchRejectDialog" title="批量驳回" width="480">
				<div class="m-reject-box">
					<label class="m-label"><span class="m-required">*</span> 驳回原因</label>
					<c-input v-model="batchAuditRemark" type="textarea" placeholder="请输入驳回原因" maxlength="200"></c-input>
					<p v-if="batchIgnoreTip" class="m-ignore-tip">{{batchIgnoreTip}}</p>
				</div>

				<template #button>
					<c-button size="dialog" color="red" @click="submitBatchReject">确认驳回</c-button>
					<c-button size="dialog" @click="$refs.batchRejectDialog.close()">取消</c-button>
				</template>
			</c-dialog>

			<!-- 批量操作结果弹窗（存在失败单时逐条给原因） -->
			<c-dialog ref="batchResultDialog" title="批量操作结果" width="520">
				<div class="m-batch-result">
					<p class="m-summary">操作完成：成功 <b class="m-ok">{{batchResult.success_count || 0}}</b> 单，失败 <b class="m-fail">{{batchResult.fail_count || 0}}</b> 单</p>
					<div class="m-fail-list">
						<p v-for="(item, i) in (batchResult.fail_list || [])" :key="i">{{item.after_sale_no}}：{{item.reason}}</p>
					</div>
				</div>

				<template #button>
					<c-button size="dialog" color="main" @click="$refs.batchResultDialog.close()">知道了</c-button>
				</template>
			</c-dialog>
		</module>
	</page>
</template>

<script>
	export default {
		data() {
			return {
				batchIds: [],
				batchIgnoreTip: '',
				batchAuditRemark: '',
				addressList: [],
				selectedAddressId: '',
				batchResult: {}
			}
		},

		methods: {
			/*********格式化价格**********/
			formatPrice(price) {
				if (price === null || price === undefined || price === '') return '-';
				return '¥' + parseFloat(price).toFixed(2);
			},

			/*********获取产品信息文字**********/
			getProductText(data) {
				var parts = [];
				if (data.brand_name) parts.push(data.brand_name);
				if (data.model_name) parts.push(data.model_name);
				if (data.memory_name) parts.push(data.memory_name);
				if (data.color_name) parts.push(data.color_name);
				return parts.join(' ') || '-';
			},

			/*********查看售后详情**********/
			viewDetail(data) {
				this.globalDialog('onlineAftersaleDetail', {
					data: {
						afterSaleId: data.after_sale_id,
						productId: data.id,
						orderType: 2
					}
				}, () => {
					this.$refs.view.update();
				});
			},


			/*********确认退货收货（后端按售后主单ID操作，列表行是商品明细维度，必须传 after_sale_id）**********/
			confirmReturn(data) {
				this.$confirm({
					message: '确认已收到售后单【' + data.after_sale_no + '】的退货商品吗？',
					buttonName: '确定',
					cancelButton: true,
					resolve: () => {
						this.request({
							url: '/aftersale/confirm_return_online',
							data: {
								id: data.after_sale_id
							},
							loading: true,
							success: (data, msg) => {
								this.$message({message: msg || '确认成功', type: 'success'});
								this.$refs.view.update();
							}
						});
					}
				});
			},

			/*********确认退款（退货退款=待商家退款(4)金额已定；仅退款=无审核环节待审核(1)直接退款通过，
			 * 按售后单登记金额提交；主单ID同上）**********/
			confirmRefund(data) {
				this.$confirm({
					message: '确认对售后单【' + data.after_sale_no + '】执行退款 ' + this.formatPrice(data.after_sale_amount) + ' 吗？',
					buttonName: '确定',
					cancelButton: true,
					resolve: () => {
						var params = {
							id: data.after_sale_id
						};
						//仅退款写接口要求填退款金额，取售后单登记金额
						if (data.after_sale_type == 2) {
							params.refund_amount = data.after_sale_amount;
						}
						this.request({
							url: '/aftersale/refund_online',
							data: params,
							loading: true,
							success: (data, msg) => {
								this.$message({message: msg || '退款成功', type: 'success'});
								this.$refs.view.update();
							}
						});
					}
				});
			},

			/*********三方同售渠道确认退机（退机后同售积分退回、背贴码恢复在售；资金由渠道侧与买家结算）**********/
			confirmReturnMachine(data) {
				this.$confirm({
					message: '确认售后单【' + data.after_sale_no + '】的退货商品已收到并退机吗？退机后同售积分将退回、背贴码恢复在售',
					buttonName: '确定',
					cancelButton: true,
					resolve: () => {
						this.request({
							url: '/aftersale/confirm_return_machine_online',
							data: {
								id: data.after_sale_id
							},
							loading: true,
							success: (data, msg) => {
								this.$message({message: msg || '确认退机成功', type: 'success'});
								this.$refs.view.update();
							}
						});
					}
				});
			},

			/*********批量入口通用筛选：常态按钮未传行时从列表选中行兜底（参照线下售出订单批量写法）；
			 * 按服务端下发的行按钮可见性过滤可选行并按售后单ID去重（同单多商品行只处理一次）**********/
			pickBatchRows(rows, buttonKey, emptyTip) {
				var list = (rows && rows.length) ? rows : this.getSelectedRows();
				if (!list.length) {
					this.$message({message: '请先勾选需要操作的数据', type: 'warn'});
					return null;
				}
				var eligible = list.filter(item => item.buttons && item.buttons[buttonKey] && item.buttons[buttonKey].visible);
				if (!eligible.length) {
					this.$message({message: emptyTip, type: 'warn'});
					return null;
				}
				var ids = [];
				eligible.forEach(item => {
					if (ids.indexOf(item.after_sale_id) == -1) ids.push(item.after_sale_id);
				});
				this.batchIds = ids;
				var ignored = list.length - eligible.length;
				this.batchIgnoreTip = ignored > 0 ? '另有' + ignored + '行当前状态不支持该操作，将自动跳过' : '';
				return eligible;
			},

			/*********从列表组件取当前选中行（operate 常态按钮点击时未传 data 的兜底），数据形状与 batchOperate 的 data 一致**********/
			getSelectedRows() {
				var listRef = this.$refs.view && this.$refs.view.$refs.list;
				return (listRef && listRef.getData('selected')) || [];
			},

			/*********批量审核：仅待审核的退货退款单可选，退货地址整批共用**********/
			batchAudit(rows) {
				if (!this.pickBatchRows(rows, 'audit', '请选择待审核的退货退款售后单')) return;
				this.selectedAddressId = '';
				this.$refs.batchAddressDialog.open();
				this.loadReturnAddressList();
			},

			/*********提交批量审核（提交所选退货地址）**********/
			submitBatchAudit() {
				var address = this.addressList.find(item => item.id == this.selectedAddressId);
				if (!address) {
					this.$message({message: '请选择退货地址', type: 'warn'});
					return;
				}
				this.submitBatch('/aftersale/audit_online_batch', {
					return_full_name: address.name,
					return_phone: address.phone,
					return_address: address.full_address
				}, 'batchAddressDialog');
			},

			/*********批量确认收货（仅用户退货中的退货退款单可选）**********/
			batchConfirmReturn(rows) {
				if (!this.pickBatchRows(rows, 'confirm_return', '请选择用户退货中状态的退货退款售后单')) return;
				this.$confirm({
					message: '确认已收到已选的' + this.batchIds.length + '单售后单的退货商品吗？' + (this.batchIgnoreTip ? '（' + this.batchIgnoreTip + '）' : ''),
					buttonName: '确定',
					cancelButton: true,
					resolve: () => {
						this.submitBatch('/aftersale/confirm_return_online_batch');
					}
				});
			},

			/*********批量确认退款（退货退款=待商家退款；仅退款=待审核，金额按各单登记金额原路退还）**********/
			batchConfirmRefund(rows) {
				if (!this.pickBatchRows(rows, 'refund', '请选择待商家退款或待审核仅退款状态的售后单')) return;
				this.$confirm({
					message: '确认对已选的' + this.batchIds.length + '单售后单执行退款吗？退款金额按各售后单登记金额原路退还' + (this.batchIgnoreTip ? '（' + this.batchIgnoreTip + '）' : ''),
					buttonName: '确定',
					cancelButton: true,
					resolve: () => {
						this.submitBatch('/aftersale/refund_online_batch');
					}
				});
			},

			/*********批量确认退机（三方渠道待审核的退货退款单；退机后同售积分退回、背贴码恢复在售）**********/
			batchConfirmReturnMachine(rows) {
				if (!this.pickBatchRows(rows, 'return_machine', '请选择三方渠道待审核的退货退款售后单')) return;
				this.$confirm({
					message: '确认已选的' + this.batchIds.length + '单售后单的退货商品已收到并退机吗？退机后同售积分将退回、背贴码恢复在售' + (this.batchIgnoreTip ? '（' + this.batchIgnoreTip + '）' : ''),
					buttonName: '确定',
					cancelButton: true,
					resolve: () => {
						this.submitBatch('/aftersale/confirm_return_machine_online_batch');
					}
				});
			},

			/*********批量驳回：待审核（自营/三方）或待商家退款单可选，原因必填**********/
			batchReject(rows) {
				if (!this.pickBatchRows(rows, 'reject', '请选择待审核或待商家退款状态的售后单')) return;
				this.batchAuditRemark = '';
				this.$refs.batchRejectDialog.open();
			},

			/*********提交批量驳回**********/
			submitBatchReject() {
				if (!this.batchAuditRemark.trim()) {
					this.$message({message: '请输入驳回原因', type: 'warn'});
					return;
				}
				this.submitBatch('/aftersale/reject_online_batch', {audit_remark: this.batchAuditRemark.trim()}, 'batchRejectDialog');
			},

			/*********加载退货地址列表**********/
			loadReturnAddressList() {
				this.request({
					url: '/sys_saas/address/list/noPage',
					data: {
						address_type: 2,
						is_enable: 1
					},
					success: data => {
						this.addressList = data || [];
						if (!this.selectedAddressId) {
							var defaultAddress = this.addressList.find(item => item.is_default == 1) || this.addressList[0];
							if (defaultAddress) {
								this.selectedAddressId = defaultAddress.id;
							}
						}
					}
				});
			},

			/*********批量提交通用：成功后刷新列表，有失败单开结果弹窗逐条给原因**********/
			submitBatch(url, extraData, closeRef) {
				var data = {
					ids: this.batchIds.join(',')
				};
				if (extraData) {
					Object.assign(data, extraData);
				}
				this.request({
					url: url,
					data: data,
					loading: true,
					success: (res, msg) => {
						/**仅关闭本次入口开过的弹窗，避免操作未打开的弹窗*/
						if (closeRef) {
							this.$refs[closeRef].close();
						}
						this.$refs.view.update();
						var failCount = (res && res.fail_count) || 0;
						/**有失败明细单独开结果弹窗逐条给原因，toast 只留汇总*/
						if (failCount) {
							this.batchResult = res;
							this.$nextTick(() => {
								this.$refs.batchResultDialog.open();
							});
							return;
						}
						this.$message({message: msg || '批量操作完成', type: 'success'});
					}
				});
			},
		}
	}
</script>

<style lang="stylus" scoped>
	.m-reject-box {
		padding: 10px;

		.m-label {
			display: block;
			margin-bottom: 8px;
			font-size: 14px;
			color: #333;

			.m-required {
				color: #f5222d;
				margin-right: 2px;
			}
		}

		.m-ignore-tip {
			margin-top: 8px;
			font-size: 12px;
			color: #999;
		}
	}

	.m-return-address-box {
		padding: 20px;

		.m-label {
			display: block;
			margin-bottom: 8px;
			font-size: 14px;
			color: #333;

			.m-required {
				color: #f5222d;
				margin-right: 2px;
			}
		}

		.m-ignore-tip {
			margin-top: 8px;
			font-size: 12px;
			color: #999;
		}
	}

	.m-return-address-list {
		min-height: 150px;
		max-height: 320px;
		overflow-y: auto;

		.m-return-address-item {
			display: flex;
			align-items: flex-start;
			gap: 8px;
			padding: 10px 12px;
			margin-bottom: 10px;
			border: 1px solid #e8e8e8;
			border-radius: 4px;
			cursor: pointer;
			font-size: 13px;
			color: #333;
			transition: all 0.2s;

			&:last-child {
				margin-bottom: 0;
			}

			&:hover {
				border-color: #3D5EFF;
			}

			.m-radio {
				flex-shrink: 0;
				width: 14px;
				height: 14px;
				margin-top: 3px;
				border-radius: 50%;
				border: 1px solid #ccc;
				position: relative;

			}

			.m-return-address-text {
				flex: 1;
				min-width: 0;
				line-height: 1.5;
				word-break: break-all;
				.m-return-address-contact,
				.m-return-address-addr {
					display: block;
				}
			}

			&.m-active {
				border-color: #3D5EFF;
				background: #f5f7ff;

				.m-radio {
					border-color: #3D5EFF;

					&:after {
						content: '';
						position: absolute;
						left: 50%;
						top: 50%;
						width: 6px;
						height: 6px;
						background: #3D5EFF;
						transform: translate(-50%, -50%);
					}
				}
			}
		}

		.m-return-address-empty {
			text-align: center;
			color: #999;
			padding: 30px 0;
			font-size: 13px;
		}
	}

	.m-batch-result {
		padding: 10px 15px;

		.m-summary {
			padding: 8px 10px;
			margin-bottom: 10px;
			font-size: 14px;
			background: #f5f7fa;
			border-radius: 4px;

			.m-ok {
				color: #52c41a;
			}

			.m-fail {
				color: #f5222d;
			}
		}

		.m-fail-list {
			max-height: 300px;
			overflow-y: auto;

			p {
				line-height: 22px;
				font-size: 13px;
				color: #666;
			}
		}
	}

	.m-product-info {
		line-height: 24px;
		font-size: 13px;
		color: #333;

		.m-product-info-name {
			display: flex;
			align-items: center;
			gap: 4px;
		}

		.m-product-info-code {
			color: #999;
			font-size: 12px;
		}
	}
</style>
